import { Toolbar as RaToolbar, SaveButton } from "react-admin";

import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { Button } from "@material-ui/core";
import React from "react";
import { useResourcePermissions } from "../usePermissions";
import { withStyles } from "@material-ui/core";
import { withTranslate } from "react-admin";

const Toolbar = withStyles((theme) => ({
  toolbar: {
    "& button": {
      marginRight: theme.spacing.unit * 2,
    },
  },
}))(({ classes, translate, ...props }) => {
  const { edit, create } = useResourcePermissions(props);

  const handleBack = () => {
    const search = window.location.search || window.location.hash.split("?")[1];
    let parentId = null;

    try {
      const params = new URLSearchParams(search);
      parentId = params.get("parent_id");
    } catch {
      parentId = null;
    }

    const locationId =
      parentId === "null" || parentId === null ? null : parseInt(parentId, 10);
    const url = `#/location?filter=${encodeURIComponent(
      JSON.stringify({ location_id: locationId })
    )}`;
    window.location.href = url;
  };

  return (
    <RaToolbar {...props} classes={classes}>
      <SaveButton {...props} disabled={!edit || !create} />
      <Button
        // variant="outlined"
        // color="default"
        onClick={handleBack}
        // startcon={<ArrowBackIcon />}
      >
        {/* Indietro */}
        <ArrowBackIcon /> {translate("ra.action.back")}
      </Button>
    </RaToolbar>
  );
});

export default withTranslate(Toolbar);
